import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import vailcode from "@utils/errcode";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      formData: {},
      isSubmit: false
    };
  },
  watch: {
    "$parent.popRefShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.formData = Object.assign({}, this.$parent.selectItem);
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      let rs = await this.$http.post("/userassets/remark", this.formData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getDataList();
        this.$parent.popRefShow = false;
      });
    }
  }
};